import { PLATFORM_ROUTES } from '@frontend/routing';
import {
  HEADER_VARIANTS,
  THeaderVariants,
} from '@customer-platform-shared/components/PlatformHeader/PlatformHeader.types';
import { Button } from '@frontend/ui-elements';
import { RiArrowRightUpLine } from '@remixicon/react';
import { Translate } from '@frontend/translation';

export const LoginButton = () => (
  <Button buttonType="primary" href={PLATFORM_ROUTES.login} size="large">
    <Translate id="customer-platform.shared.login.login-form.button.login" />
  </Button>
);

export const SignUpButton = () => (
  <Button
    buttonType="primary"
    endIcon={<RiArrowRightUpLine size={24} />}
    href={PLATFORM_ROUTES.signUp}
    size="large"
  >
    <Translate id="customer-platform.header.sign-up" />
  </Button>
);

interface IOpenVariantFormDrawerButton {
  openFormDrawer: () => void;
  variant: THeaderVariants;
}
export const OpenVariantFormDrawerButton = ({
  variant,
  openFormDrawer,
}: IOpenVariantFormDrawerButton) => {
  const VARIANT_BUTTON_TYPE = {
    [HEADER_VARIANTS.BUYER]: 'request',
    [HEADER_VARIANTS.SELLER]: 'listing',
  };
  const getVariantType = VARIANT_BUTTON_TYPE[variant] || '';

  return (
    <Button
      buttonType="primary"
      endIcon={<RiArrowRightUpLine size={24} />}
      id={`user-header.button.open-create-${getVariantType}-drawer`}
      onClick={openFormDrawer}
      size="large"
    >
      <Translate
        id={`customer-platform.header.user.menu.cta.create-${getVariantType}`}
      />
    </Button>
  );
};
